var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "applyInfoForm",
                attrs: {
                  model: _vm.applyData,
                  "label-position": _vm.labelPosition,
                  "label-width": "140px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex", justify: "right" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.historyBack },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.close")))]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("apply.no") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { readonly: "" },
                              model: {
                                value: _vm.applyData.applyNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "applyNo", $$v)
                                },
                                expression: "applyData.applyNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apply.applyType"),
                              prop: "applyType",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { readonly: "" },
                              model: {
                                value: _vm.applyData.applyTypeI18n,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "applyTypeI18n", $$v)
                                },
                                expression: "applyData.applyTypeI18n",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 17 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("apply.subject") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { readonly: "" },
                              model: {
                                value: _vm.applyData.subject,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "subject", $$v)
                                },
                                expression: "applyData.subject",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apply.shortlistedSuppliers"),
                              prop: "supplierNames",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { readonly: "" },
                              model: {
                                value: _vm.applyData.supplierNames,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "supplierNames", $$v)
                                },
                                expression: "applyData.supplierNames",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("apply.quotationType") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { readonly: "" },
                              model: {
                                value: _vm.applyData.quotationTypeI18n,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.applyData,
                                    "quotationTypeI18n",
                                    $$v
                                  )
                                },
                                expression: "applyData.quotationTypeI18n",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("common.createBy") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { readonly: "" },
                              model: {
                                value: _vm.applyData.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "name", $$v)
                                },
                                expression: "applyData.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("common.createDate") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { readonly: "" },
                              model: {
                                value: _vm.applyData.createDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyData, "createDate", $$v)
                                },
                                expression: "applyData.createDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: _vm.$t("apply.lineDetail"), name: "line" } },
              [
                _c(
                  "el-table",
                  {
                    ref: "applyLineTableDataRef",
                    staticClass: "table",
                    attrs: {
                      data: _vm.applyLineTableData,
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "pickupPoint",
                        align: "center",
                        label: _vm.$t("base.pp.pickupPoint"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "dcName",
                        align: "center",
                        label: _vm.$t("apply.dc"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "temperatureI18n",
                        align: "center",
                        label: _vm.$t("apply.temperature"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "transportaionMethodI18n",
                        align: "center",
                        label: _vm.$t("apply.transportaionMethod"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "unitI18n",
                        align: "center",
                        label: _vm.$t("apply.unit"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "effectiveBeginDate",
                        label: _vm.$t("apply.effectiveBeginDate"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("dateFormatFilter")(
                                      scope.row.effectiveBeginDate,
                                      "YYYY-MM-DD"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "remarks",
                        align: "center",
                        label: _vm.$t("common.remarks"),
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("common.attachment"),
                  name: "enclosure",
                },
              },
              [
                _c(
                  "el-table",
                  {
                    staticClass: "table",
                    attrs: {
                      data: _vm.fileList,
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "documentName",
                        label: _vm.$t("common.file"),
                        "min-width": "130px",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.downloadFile(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.documentName) + " ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "userName",
                        label: _vm.$t("common.createBy"),
                        "min-width": "130px",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "createDate",
                        label: _vm.$t("common.createDate"),
                        "min-width": "130px",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("dateFormatFilter")(
                                      scope.row.createDate,
                                      "YYYY-MM-DD HH:mm"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }